module.exports = __webpack_public_path__ + "static/media/Story_3_Card.eaef509a.jpg";